<script lang="ts">
	import Modal, { type ModalProps } from '$lib/modal/v3/modal.svelte';
	import { type Snippet } from 'svelte';
	import { trackEvent } from '$lib/segment/client';
	import { toString } from '$lib/utils/storyblok/richtext';
	import type { ISbRichtext } from '@storyblok/js';
	import { EmailModal } from '$lib/state/emailModal.svelte';
	import { page } from '$app/state';

	interface Props {
		openDelay: number;
		ignoredParams?: Array<string>;
		title?: ISbRichtext;
		text?: ISbRichtext;
		children: Snippet;
		modal?: { show: () => void; hide: () => void; remove: () => void };
		size?: ModalProps['size'];
		eventName?: string;
		modalParam?: string;
	}

	let {
		children,
		openDelay,
		ignoredParams = [],
		title,
		text,
		modal = $bindable(),
		size = 'regular',
		eventName = 'Show Email Capture Modal',
		modalParam = 'newsletter'
	}: Props = $props();

	export const emailModal = new EmailModal({
		ignoredParams,
		openDelay: openDelay * 1000,
		modalParam
	});

	$effect.pre(() => {
		emailModal.show();
	});

	let modalIsOpen = $state(false);

	$effect.pre(() => {
		if (emailModal.isShown && !modalIsOpen) {
			modal?.show();
		} else if (!emailModal.isShown && modalIsOpen) {
			modal?.hide();
		}
	});
</script>

<Modal
	bind:this={modal}
	{size}
	onclose={() => {
		emailModal.hide();
		modalIsOpen = false;
	}}
	onopen={() => {
		modalIsOpen = true;
		trackEvent(eventName, {
			path: page.url.pathname,
			delay: openDelay,
			title: title ? toString(title) : '',
			text: text ? toString(text) : ''
		});
	}}
>
	{@render children()}
</Modal>
